import { DateTime } from 'luxon';

export const ROLE_LABELS = {
	master: 'Super Admin',
	admin: 'Διαχείριση',
	shop: 'Κατάστημα',
	delivery: 'Διανομέας',
	order: 'Παραγγελία',
};

export const STATUS_LABELS = { open: 'Ανοιχτή', closed: 'Κλειστή', archived: 'Αρχείο' };

// "14:05" today, "Χθες", "Δευ 29/09" this week, else "29/09/26".
export const fmtWhen = iso => {
	if (!iso) return '';
	const d = DateTime.fromISO(iso).setLocale('el');
	const now = DateTime.local();
	if (d.hasSame(now, 'day')) return d.toFormat('HH:mm');
	if (d.hasSame(now.minus({ days: 1 }), 'day')) return 'Χθες';
	if (now.diff(d, 'days').days < 7) return d.toFormat('ccc dd/MM');
	return d.toFormat('dd/MM/yy');
};

export const fmtTime = iso => (iso ? DateTime.fromISO(iso).toFormat('HH:mm') : '');
export const fmtDay = iso =>
	iso ? DateTime.fromISO(iso).setLocale('el').toFormat('cccc dd/MM/yyyy') : '';
export const fmtFull = iso => (iso ? DateTime.fromISO(iso).toFormat('dd/MM/yyyy HH:mm') : '');
